import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubreddits,
  selectSubreddits,
} from "../../features/subreddits/subredditsSlice";
import "./Side.css";
import { Link } from "react-router-dom";

export default function Side({ handleToggleClick }) {
  const dispatch = useDispatch();

  // This will fetch the subreddits data and update the state

  useEffect(() => {
    dispatch(getSubreddits());
  }, [dispatch]);

  const subreddits = useSelector(selectSubreddits);

  return (
    <ul>
      {subreddits.map((subreddit) => {
        return (
          <li key={subreddit.data.id} onClick={() => handleToggleClick()}>
            <span className="link">
              <Link
                to={`${subreddit.data.display_name_prefixed}`}
                className="link"
              >
                <span className="title">{subreddit.data.display_name}</span>
              </Link>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
